import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const MissingItemsPage = lazy(() => import('./components/MissingItemsPage'));

const missingItemsRoutes: FuseRouteItemType[] = [
	{
		path: 'missing-items',
		children: [
			{
				index: true,
				element: <MissingItemsPage />
			}
		]
	}
];

export default missingItemsRoutes;
